var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompetitor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 216,
    height: 216,
    viewBox: "0 0 216 216",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.75 216C172.315 216.003 170.906 215.626 169.664 214.907C168.422 214.189 167.393 213.155 166.68 211.91L127.93 144.53C110.261 152.405 90.2449 153.207 72.0021 146.771C53.7594 140.335 38.6778 127.151 29.8616 109.932C21.0454 92.7129 19.1654 72.7694 24.6084 54.2062C30.0515 35.643 42.4035 19.8725 59.1221 10.1408C75.8407 0.409049 95.6539 -2.54352 114.484 1.89079C133.313 6.3251 149.727 17.8089 160.346 33.9785C170.965 50.1481 174.981 69.7733 171.568 88.8146C168.156 107.856 157.574 124.865 142 136.34L180.8 203.8C181.51 205.034 181.884 206.432 181.885 207.855C181.886 209.278 181.514 210.677 180.805 211.911C180.097 213.146 179.077 214.173 177.848 214.89C176.619 215.608 175.223 215.99 173.8 216H173.75ZM97.2 16.63C85.5479 16.628 74.1568 20.0816 64.4676 26.554C54.7784 33.0263 47.2262 42.2267 42.7662 52.9915C38.3062 63.7563 37.1387 75.602 39.4115 87.0303C41.6842 98.4587 47.295 108.956 55.5344 117.196C63.7737 125.435 74.2713 131.046 85.6997 133.319C97.128 135.591 108.974 134.424 119.739 129.964C130.503 125.504 139.704 117.952 146.176 108.262C152.648 98.5732 156.102 87.1821 156.1 75.53C156.074 59.9169 149.86 44.9508 138.819 33.9106C127.779 22.8704 112.813 16.6564 97.2 16.63V16.63Z",
    fill: "#AAA9A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.3163 43V78.458H126C126 90.0104 116.839 105.558 100.578 107.721C82.2997 110.197 66.6857 95.8925 66.0217 76.5618C65.3576 57.2311 80.0776 43.7916 93.3163 43Z",
    fill: "#AAA9A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 38C118.482 39.3973 130.721 56.7747 131 72H100V38Z",
    fill: "#AAA9A9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 216,
    height: 216,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompetitor);
export default __webpack_public_path__ + "static/media/Competitor.c2c36694bd4e994280d4f4899ff70beb.svg";
export { ForwardRef as ReactComponent };